import axiosInstance from "helpers/api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ModernNotesList from "./ModernNotesList";
import "./LeadNotesResponsive.css"; // Import responsive styles

const LeadDetailsNotes = ({ notes }: any) => {
  const [noteItems, setNoteItems] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);

  let { id } = useParams();

  useEffect(() => {
    setNoteItems(notes);
    setIsLoading(false);
  }, [notes]);

  const handleCreateNote = async (noteData: any) => {
    try {
      await axiosInstance.post(`/leads/${id}/notes`, {
        note: noteData.note,
      });
      
      // Add the new note to the existing notes list
      const newNote = {
        note: noteData.note,
        created_on: new Date().toISOString(),
        id: Date.now().toString(), // Temporary ID until refresh
      };
      
      setNoteItems((prevNotes: any[]) => [newNote, ...prevNotes]);
      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error);
    }
  };

  return (
    <div className="modern-notes-container">
      <ModernNotesList
        notes={noteItems || []}
        isLoading={isLoading}
        onCreateNote={handleCreateNote}
      />
    </div>
  );
};

export default LeadDetailsNotes;
